<template>
  <div
    v-if="box.length && step < 4 "
    class="hb-bab-bottom-wrapper pt-1"
    :style="{ minHeight: expanded ? `calc(100vh - ${categoryNavTop})` : '0', maxHeight: expanded ? `calc(100vh - ${categoryNavTop})` : 'initial', bottom: bottomNavHeight, overflowY: expanded? 'scroll':'visible' }"
  >
    <div v-if="!expanded" class="hb-bab-bottom-toolbar px-4">
      <div
        v-if="!expanded"
        class="box-size-product d-flex mb-2"
      >
        <v-img
          v-for="(boxItem, n) in boxThumbnail"
          :key="`${boxItem.id}_index_${n}`"
          aspect-ratio="1"
          :class="{ 'mx-2': n === 1 }"
          :src="boxItem.image.src"
          style="flex: 0 0 33%; position:relative;"
          :gradient="box.length > 3 && n == 2? 'to top right, rgba(1,1,1,.5), rgba(1,1,1,.5)' : ''"
        >
          <div
            v-if="box.length > 3 && n == 2"
           class="font-weight-bold" 
           style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); color: white">
           +{{box.length - 3}}
          </div>
          <div class="box-count">{{boxItem.amount}}</div>
        </v-img>
      </div>
      <div class="box-size-price pl-1 pt-3">
        <span class="size-label">CURRENT BOX SIZE</span>
        <div ref="box-size" :class="{'box-size--medium': sizeLabel === 'medium', 'box-size--big': sizeLabel === 'big' || sizeLabel === 'big-exceed', 'box-size--pop': popBox}" class="box-size text-uppercase">
          {{sizeLabel == 'big-exceed'? 'big':sizeLabel}}
        </div>
        <div class="price" v-if="!expanded" >RM {{boxPrice}}</div>
      </div>

      <div class="box-size-expand">
        <v-btn @click="expandBottom" x-small fab color="white">
          <v-icon class="primary--text">mdi-arrow-expand</v-icon>
        </v-btn>
      </div>

    </div>
    <div v-if="!expanded" class="px-4 mt-0 mb-4 d-flex justify-space-between">
      <v-btn v-if="!isFirstStep" @click="prevStep" outlined color="primary" class="mr-2 back-button">
        <v-icon class="primary--text">mdi-arrow-left</v-icon> {{stepName.prev}}
      </v-btn>
      <v-btn v-if="box.length" @click="nextStep" class="next-button" color="primary">
        {{step == 3 && selectedCardIndex === null && (!this.$store.state.cardMessage && !this.$store.state.signoff)? 'Skip':'Next:'}}
        <span>{{step == 3 && selectedCardIndex === null && (!this.$store.state.cardMessage && !this.$store.state.signoff)? '':stepName.next}}</span>
      </v-btn>
    </div>

    <!-- expanded -->
    <div v-if="expanded" class="hb-bab-bottom-toolbar--expanded pb-5">
      <div class="d-flex justify-end align-center px-4 mt-3">
        <span class="size-label">CURRENT BOX SIZE</span>
        <div :class="{'box-size--medium': sizeLabel === 'medium', 'box-size--big': sizeLabel === 'big', 'box-size--pop': popBox}" class="box-size text-uppercase mx-3 px-3">{{sizeLabel}}</div>
        <v-btn @click="expandBottom" x-small fab color="white">
          <v-icon class="primary--text">mdi-arrow-expand</v-icon>
        </v-btn>
      </div>

      <div class="expanded-image-grid justify-space-between px-4 mb-7 mt-2">
        <v-img 
        v-for="(boxItem, boxItemIndex) in boxThumbnailExpanded" 
        :key="boxItem.id + '_image_' + boxItemIndex" 
        class="expanded-image mb-2" 
        aspect-ratio="1" 
        :src="boxItem.image.src"
        :gradient="box.length > 4 && boxItemIndex == 3? 'to top right, rgba(1,1,1,.5), rgba(1,1,1,.5)' : ''">
          <div
            v-if="box.length > 4 && boxItemIndex == 3"
           class="font-weight-bold" 
           style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); color: white">
           +{{box.length - 3}}
          </div>
          <div class="box-count">{{boxItem.amount}}</div>
        </v-img>
      </div>

      <div class="box-contents px-4">
        <p class="mb-0 section-title mt-3">Box Contents</p>
        <v-list class="pt-0" two-line>
          <v-list-item style="border-bottom: 1px solid #EAECF4" v-for="(boxItem, index) in box" :key="boxItem.id + '_list' + index" class="px-0">
            <v-list-item-content class="pt-0">
              <v-list-item-title style="overflow: visible" class="d-flex justify-space-between align-start px-2 pt-3 ">
                <span>{{boxItem.amount}}x</span>
                <span style="width: 44%; white-space: normal">{{boxItem.name || boxItem.title}}</span>
                <span>RM {{boxItem.variantPrice}}</span>
                <span>
                  <v-btn @click="toggleReplace(boxItem)" class="white" v-if="boxItem.boxContentType == 'boxType'" x-small fab>
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn @click="removeItem(index)" v-else icon>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <!-- <v-btn block>Replace Items</v-btn> -->
                <div v-if="boxItem.boxContentType != 'boxType' && !boxItem.tags.includes('flowers')" class="d-flex justify-space-around align-center counter-wrapper">
                  <v-btn @click="reduceItem(index)" class="xx-small" elevation="0" color="primary" fab x-small>
                      <v-icon>mdi-minus</v-icon>
                  </v-btn>
                    <input readonly v-model="boxItem.amount" type="text" class="pa-0">
                    <v-btn @click="increaseItem(index)" class="xx-small" elevation="0" color="primary" fab x-small>
                      <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </div>
                <!-- <div class="list-select-wrapper" v-else-if="boxItem.boxContentType == 'boxType'">
                  <v-select
                    :items="boxItem.variants.map(variant => {return {name: variant.name, value: variant.id}})"
                    item-text="name"
                    item-value="value"
                    outlined
                    hide-details
                    :value="boxItem.title"
                    v-model="boxItem.selectedVariant"
                  ></v-select>
                </div> -->
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          
        </v-list>
      </div>

      <div class="box-subtotal d-flex justify-space-between px-4">
        <span class="section-title">Box Subtotal</span>
        <span class="primary--text">RM {{boxPrice}}</span>
      </div>

      <div v-if="deliveryDate" class="selected-date px-4 mt-3">
        <div class="section-title">Selected delivery date</div>
        <span class="iconc-calendar"></span>
        <span>{{moment(deliveryDate).format('dddd, DD MMM YYYY')}}</span>
      </div>

      <div class="px-4 mt-5">
        <v-btn @click="nextStep" style="width: 100%" color="primary">
          {{step == 3 && selectedCardIndex === null && (!this.$store.state.cardMessage && !this.$store.state.signoff) ? 'Skip':'Next'}}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {
  TYPE_SET_BOTTOM_TOOLBAR_EXPANDED, TYPE_SET_REPLACE_ITEM, TYPE_SET_SCREEN,
} from "../store/mutations";
import{
  ACTION_MODIFY_BOX,
  ACTION_GO_BACK,
  ACTION_GO_NEXT
} from "../store/actions"
export default {
  name: "hb-bab-bottom-toolbar",
  mounted() {
    setTimeout(()=>{
      this.bottomNavHeight = document.querySelector(".mobile-nav-footer").clientHeight + 'px';
    },1000)
  },
  data() {
    return {
      categoryNavTop: "",
      bottomNavHeight: '',
      popBox: false
    };
  },
  methods: {
    nextStep() {
      document.querySelector("#hb-bab-stepper").scrollIntoView();
      this.$store.dispatch(ACTION_GO_NEXT);
      this.expanded = false;
    },
    prevStep(){
      this.$store.dispatch(ACTION_GO_BACK);
    },
    reduceItem(index){
      if(this.box[index].amount == 0) return;
      this.$store.dispatch(ACTION_MODIFY_BOX, 
      {
        product: this.box[index], 
        amount: this.box[index].amount - 1, 
        boxContentType: this.box[index].boxContentType
      });
    },
    increaseItem(index){
      this.$store.dispatch(ACTION_MODIFY_BOX, 
      {
        product: this.box[index], 
        amount: this.box[index].amount + 1, 
        boxContentType: this.box[index].boxContentType
      });
    },
    removeItem(index){
      this.$store.dispatch(ACTION_MODIFY_BOX, 
      {product: this.box[index], 
      amount: 0, 
      boxContentType: this.box[index].boxContentType});
    },
    expandBottom(){
      this.categoryNavTop = document.querySelector(".main-header-wrapper").clientHeight + document.querySelector(".mobile-nav-footer").clientHeight + "px";
      this.expanded = !this.expanded
    },
    toggleReplace(boxItem){
      document.documentElement.style.overflowY = '';
      this.$store.commit(TYPE_SET_REPLACE_ITEM, boxItem);
      this.$store.commit(TYPE_SET_SCREEN, 'replace');
    },
    moment
  },
  computed: {
    expanded: {
      get() {
        return this.$store.state.bottomToolbarExpanded;
      },
      set(value) {
        this.$store.commit(TYPE_SET_BOTTOM_TOOLBAR_EXPANDED, value);
      },
    },
    box(){
      return this.$store.state.box;
    },
    boxPrice(){
      return this.$store.getters.boxPrice;
    },
    boxThumbnail(){
      return this.$store.state.box.slice(0, 3);
    },
    boxThumbnailExpanded(){
      return this.$store.state.box.slice(0, 4);
    },
    step(){
      return this.$store.state.step;
    },
    substep(){
      return this.$store.state.substep;
    },
    summaryStep(){
      return this.$store.state.summaryStep;
    },
    isFirstStep(){
      return this.substep === 1 && this.step === 1;
    },
    sizeLabel(){
      return this.$store.getters.boxSize;
    },
    deliveryDate(){
      return this.$store.state.delivery.delivery_date;
    },
    selectedCardIndex(){
      return this.$store.state.selectedCardIndex;
    },
    stepName(){
      return this.$store.getters.stepName;
    }
  },
  watch: {
    expanded(val) {
      if (val == true) {
        document.documentElement.style.overflowY = 'hidden';
      } else {
        document.documentElement.style.overflowY = '';
      }
    },
    sizeLabel(val){
      this.popBox = true;
      setTimeout(() => {
        this.popBox = false;
      }, 500);
    }
  },
};
</script>

<style scoped>
.xx-small{
  height: 25px;
  width: 25px;
}

.box-size--pop{
  animation-name: pop;
  animation-duration: .5s;
}

.back-button{
  flex: 1 0 18%;
}

.next-button{
  flex: 1 0 80%
}

@keyframes pop {
  0%{
    transform: scale(1);
  }

  50%{
    transform: scale(1.1);
  }

  100%{
    transform: scale(1);
  }
}

@media screen and (min-width: 768px) {
  .back-button{
    flex: 0 0 18%;
  }

  .next-button{
    flex: 0 0 30%
  }
}
</style>